import React from "react";
import { Link, Outlet } from "react-router-dom";
import LabradorSvg from "../../assets/svgs/labradorSvg";
import "./styles.css";

const Header = () => {
  return (
    <div className="header">
      <span>
        <div>
          <a className="header-item" href="/">
            <LabradorSvg />
          </a>
        </div>
      </span>

      <span>
        <div>
          <a href="/about" className="header-item">
            About
          </a>
        </div>
      </span>
    </div>
  );
};
const Layout = () => {
  return (
    <div className="body">
      <Header />
      <div className="outlet-container">
        <div className="outlet-style">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
